import React from 'react';
import App from '../../../models/app';

export interface ModalProps {
  onCancel: () => void;
  onSuccess: () => void;
  app: App;
  deviceName?: string;
  parentApp?: App;
  loading?: boolean;
}

export type StringOrReactElement = string | React.ReactNode;

export interface ModalButtonProps {
  highlight?: boolean;
}

export interface Button extends ModalButtonProps {
  text: StringOrReactElement;
  onClick?: () => void;
  id: string;
  loading: boolean;
  disabled?: boolean;
  to?: string;
  pageDirection?: string;
}

export interface ModalButtons {
  buttons: Button[];
}

export interface ModalContent extends ModalButtons {
  contentAbove: StringOrReactElement;
  contentCenter: StringOrReactElement;
  title: string;
}

export interface DisplayOptions {
  currentlySyncing: boolean;
  requiresSync: boolean;
  parentApp?: App;
  tiles?: App[];
  parentAppInstalled?: boolean;
  features?: any;
}

export enum MODALS {
  WAIT = 'wait',
  UNINSTALL = 'uninstall',
  PRIVATE = 'private',
  PERMISSION = 'permission',
  APP_IS_PAID = "app_is_paid",
  UNINSTALL_TILE = "uninstall_tile",
  INSTALL_TILE = "install_tile",
  INSTALL_TILE_AND_APP = "install_tile_and_app",
  TOO_FEW_TILES = 'too_few_tiles',
  TOO_MANY_TILES = 'too_many_tiles'
}

export enum ACTIONS {
  INSTALL = 'install',
  UPDATE = 'update',
  UNINSTALL = 'uninstall',
}

export interface ModalType {
  ModalComponent: React.ComponentType<ModalProps>;
  name: MODALS;
  shouldDisplay: (app: App, options: DisplayOptions) => boolean;
}

export enum ButtonType {
  PROGRESS = 'progress',
  LOADING = 'loading',
  UPDATE = 'update',
  UNINSTALL = 'uninstall',
  INSTALL = 'install',
  DISABLED = 'disabled',
}

interface ButtonComponentDisplayOptions {
  loading?: boolean;
  showRemove?: boolean;
  onUninstall?: () => void;
  action?: ACTIONS;
}

export interface ButtonTextTranslations {
  [key: string]: string;
}

interface ButtonComponentOptions {
  texts: ButtonTextTranslations;
}

interface ButtonPropsType {
  id?: string;
  ariaLabel?: string;
  backgroundColor?: string;
  icon?: any;
  color?: string;
}

export interface ButtonComponentType {
  shouldDisplay: (app: App, options: ButtonComponentDisplayOptions) => boolean;
  ButtonComponent?: (app: App, options: ButtonComponentOptions) => any;
  action?: ACTIONS;
  textKey?: string;
  props?: ButtonPropsType | ((app: App) => ButtonPropsType);
  modals?: MODALS[];
  name: ButtonType;
}
